import { getTimer } from '../TimerUtils';

export default class InstructionPlayer {
    constructor(testElement) {
        this.signal = null;
        this.testElement = testElement;
        this.isSkipped = false;
        this.displayTimeout = null;
        this.position = null;
        this.isStarted = false;
        this.timerInterval = null;
        this.updatePositionTimeout = null;
        this.isActive = false;
        this.stateChangedCallback = null;
        this.testArticleElement = document.getElementById('test');
        this.cutoffTimer = document.getElementById('cutoffTimer');
        this.isPreloaded = true; //Note: just for easier preaload checking for all kind of players
    }

    start() {
        return new Promise((resolve) => {
            this.signal = resolve;
            this.stateChanged(this.testElement);
            this.isStarted = true;
            this.isSkipped = false;

            this._show();

            this.position = 0;
            if (this.updatePositionTimeout) {
                clearTimeout(this.updatePositionTimeout);
            }

            const updatePosition = () => {
                return setTimeout(() => {
                    this.position += 100;
                    if (this.position < this.testElement.cutoffTime) {
                        this.updatePositionTimeout = updatePosition();
                    } else {
                        clearTimeout(this.updatePositionTimeout);
                        this.onStop();
                    }
                }, 100);
            };

            this.updatePositionTimeout = updatePosition();
            this.stateChanged(this.testElement);
        });
    }

    stop() {
        if (this.displayTimeout) {
            clearTimeout(this.displayTimeout);
        }
        if (this.updatePositionTimeout) {
            clearTimeout(this.updatePositionTimeout);
        }
        this.onStop();
    }

    getPosition() {
        const res = {};
        if (this.testElement) {
            res.elementId = this.testElement.testElementSequenceID;
            res.position = this.position;
        }
        return res;
    }

    stateChanged() {
        if (this.stateChangedCallback) {
            try {
                this.stateChangedCallback(this.testElement);
            } catch (e) {}
        }
    }

    onStateChange(clbck) {
        if (clbck) {
            this.stateChangedCallback = clbck;
        }
    }

    onStop() {
        this.stateChanged(this.testElement);
        if (this.displayTimeout) {
            clearTimeout(this.displayTimeout);
        }

        this.isStarted = false;
        this._hide();

        this.signal();
    }

    close() {
        if (this.isStarted) {
            this.onStop();
        }
    }

    _show() {
        if (!this.testElement) {
            return;
        }

        if (this.testElement.metaData) {
            document.getElementById('instruction').innerHTML = `<span>${this.testElement.metaData.replace(/\n/g, '<br/>')}</span>`;
        }

        if (this.testElement.displayTimer) {
            this.timerInterval = setInterval(() => {
                const rest = (this.testElement.cutoffTime - (new Date() - startTime)) / 1000;
                if (this.cutoffTimer) {
                    this.cutoffTimer.innerText = getTimer(rest);
                }
            }, 500);
        }
    }

    skip() {
        clearTimeout(this.displayTimeout);
        this.isSkipped = true;
        this.onStop();
    }

    _hide() {
        document.getElementById('instruction').innerHTML = '';
        if (this.cutoffTimer) {
            this.cutoffTimer.innerText = '';
        }

        if (this.timerInterval) {
            clearInterval(this.timerInterval);
        }
    }
}
